import React from 'react';
import {fromJS} from 'immutable';
import * as logistics from './logistics.jsx';

const ACTIONS = {
  LOADING: 'LOADING',
  INITIAL: 'INITIAL'
};

class SIMCardsPage extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
        status: ACTIONS.LOADING,
        simCard: undefined,
        dataInfo: undefined,
        providerSimCardState: '',
        showServiceProviderResponse: false,
        serviceProviderResponse: ''
    };
  };

  componentWillMount() {
    this.loadSIMCard();
    this.loadSIMState();
    this.loadSimDataLimitAndUsage();
  };

  setStateFromResponse(response, status) {
    this.setState({
      status: status,
      simCard: response.data.simCard ? response.data.simCard : response.data
    });
  };

  setDataLimitAndUsageFromResponse(response, status) {
    this.setState({
      status: status,
      dataInfo: response.data
    });
  };

  setSIMStateFromResponse(response) {
    const simState = response.data.providerSimState === undefined ? 'N/A' : response.data.providerSimState.humanize()
    this.setState({
      providerSimCardState: simState,
      serviceProviderResponse: response.data.serviceProviderResponse
    });
  };

  loadSIMCard() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/simCards/${this.props.simCardUUID}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setStateFromResponse(response,ACTIONS.INITIAL);
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("simCardHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("simCardHeader");
    });
  };

  loadSimDataLimitAndUsage() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/simCards/${this.props.simCardUUID}/dataLimitAndUsage`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setDataLimitAndUsageFromResponse(response,ACTIONS.INITIAL);
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("simCardHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("simCardHeader");
    });
  };

  loadSIMState() {
      radio('showLoader').broadcast();
      $.ajax({
          url: `/api/simCards/${this.props.simCardUUID}/status`,
          method: 'GET'
      }).done((response) => {
          if (response.status === 200) {
              this.setSIMStateFromResponse(response);
          } else {
              radio('showAlert').broadcast('danger', `Error while retrieving SIM status: ${response.message} (${response.status})`);
          }
      }).fail((_, textStatus) => {
          radio('hideLoader').broadcast();
          radio('showAlert').broadcast('danger', 'Error while retrieving SIM status: ' + textStatus);
      });
  };

  activateSIM() {
      const url = `/api/simCards/${this.props.simCardUUID}/activate`
      this.postAndReloadSIMState(url)
  };

  suspendSIM() {
      const url = `/api/simCards/${this.props.simCardUUID}/suspend`
      this.postAndReloadSIMState(url)
  };

  unsuspendSIM() {
      const url = `/api/simCards/${this.props.simCardUUID}/unsuspend`
      this.postAndReloadSIMState(url)
  };

  postAndReloadSIMState(url) {
      radio('showLoader').broadcast();
      $.ajax({
          url: url,
          method: 'POST'
      }).done((response) => {
          if (response.status === 200) {
              this.loadSIMState()
          } else {
              radio('showAlert').broadcast('danger', `Error: ${response.message} (${response.status})`);
          }
      }).fail((_, textStatus) => {
          radio('hideLoader').broadcast();
          radio('showAlert').broadcast('danger', 'Error: ' + textStatus);
      });
  }

  render() {
    if(this.state.status !== ACTIONS.LOADING) {
      return (
        <div className='simCardMainContainer'>
          {this.getHeader()}
            <DetailsContainer
              simCard={fromJS(this.state.simCard)}
              providerSimCardState={this.state.providerSimCardState}
              serviceProviderResponse={this.state.serviceProviderResponse}
              showServiceProviderResponse={this.state.showServiceProviderResponse}
              toggleServiceProviderResponse={() => this.toggleServiceProviderDetails()}
              dataInfo={this.state.dataInfo ? fromJS(this.state.dataInfo) : null}
          />
          <DetailsSubContainer heading='SIM Tracking Data'
                               rows={<TrackingDataRows
                                 fulfilmentState={fromJS(this.state.simCard).get('simFulfilmentState')}
                                 location={fromJS(this.state.simCard).get('simLocation')}
                               />}/>
          {this.getAllocateToReaderBlock()}
          {this.getAllocateToFulfilmentBlock()}
        </div>
      );
    }
    return <div/>;
  };

  getButton(title, onPress, type='info') {
      return <HeaderButton
          buttonText={title}
          buttonType={`btn-${type} simCardHeaderButton`}
          onPress={onPress}
      />
  }

  getHeader() {
      let deallocateButton = '';
      if (this.state.simCard.cardReaderSerialNumber) {
          deallocateButton = this.getButton('Deallocate', () => this.deallocateFromCardReader(), 'warn')
      }
      let activateButton = '';
      if (this.state.providerSimCardState !== 'Activated' && this.state.simCard.serviceProvider !== 'ionline') {
          activateButton = this.getButton('Activate', () => this.activateSIM())
      }
      let suspendButton = '';
      if (this.state.providerSimCardState === 'Activated') {
          suspendButton = this.getButton('Suspend', () => this.suspendSIM(), 'warn')
      }
      let unsuspendButton = '';
      if (this.state.providerSimCardState === 'Suspended') {
          unsuspendButton = this.getButton('Unsuspend', () => this.unsuspendSIM())
      }

      return (
          <header className='simCardHeader'>
              <h1>
                  SIM Card
              </h1>
              <div className='simCardHeaderButtons'>
                  {deallocateButton}
                  {activateButton}
                  {suspendButton}
                  {unsuspendButton}
              </div>
          </header>
      );
  }

  getAllocateToReaderBlock() {
    if (fromJS(this.state.simCard).get('cardReaderUUID', '') !== '') {
      return '';
    }
    return <AllocateToReaderBlock
        simUUID={this.props.simCardUUID}
        user_uuid={this.props.user_uuid}
        setStateFromResponse={(response, status) => this.setStateFromResponse(response, status)}
        scrollToElement={(element) => this.scrollToElement(element)}
    />
  };

  getAllocateToFulfilmentBlock() {
    if (fromJS(this.state.simCard).get('businessUUID', '') !== '') {
      return '';
    }
    return <FulfilmentAllocationsBlock
      businessUUID={this.props.businessUUID}
      simUUID={this.props.simCardUUID}
      simCard={this.state.simCard}
      setStateFromResponse={(response, status) => this.setStateFromResponse(response, status)}
      scrollToElement={(element) => this.scrollToElement(element)}
    />
  };

  scrollToElement(elementClassName) {
    document.getElementsByClassName(elementClassName)[0].scrollIntoView({
      behavior: 'smooth'
    });
  }

  toggleServiceProviderDetails() {
      const showServiceProviderResponse = !this.state.showServiceProviderResponse
      this.setState({
          showServiceProviderResponse: showServiceProviderResponse
      })
  }

  deallocateFromCardReader() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/simCards/${this.props.simCardUUID}/deallocate`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({serialNumber: this.state.simCard.cardReaderSerialNumber, updatedByUUID: this.props.user_uuid})
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setStateFromResponse(response, ACTIONS.INITIAL);
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    })
  }
}

const HeaderButton = ({buttonText,buttonType,onPress}) => (
    <button
        type="button"
        className={buttonType}
        onClick={onPress}
    >
      {buttonText}
    </button>
);

const DetailsContainer = ({simCard, providerSimCardState, serviceProviderResponse, showServiceProviderResponse, toggleServiceProviderResponse, dataInfo}) => (
    <div className='simCardDetailsContainer'>
        {simCard.get('fulfilmentId') ?
            <DetailsRow text='Associated Fulfilment:'
                        value={
                            <a href={`/logistics/orders/fulfilments/${simCard.get('fulfilmentId')}/`}> View
                                fulfilment</a>
                        }
            /> : null
        }
      <DetailsRow text='SIM Number:'
                  value={simCard.get('simNumber', '')}
      />
      <DetailsRow text='Business:'
                  value={
                    <a href={`/businesses/${simCard.get('businessUUID')}`}>{simCard.get('businessName')}</a>}
                  />
      <DetailsRow text='Yoco SKU:'
                  value={simCard.get('yocoSku')}
      />
      <DetailsRow text='Service provider:'
                  value={
                      <a href={`${simCard.get('serviceProviderPortalLink')}`}>{simCard.get('serviceProvider').humanize()}</a>}
      />
      <DetailsRow text='Card Reader:'
                  value={
                      <a href={`/logistics/card-readers/${simCard.get('cardReaderUUID')}`}>{simCard.get('cardReaderSerialNumber')}</a>}
      />
      <DetailsRow text='Card Reader IMEI:'
                  value={simCard.get('cardReaderIMEI')}
      />
      <DetailsRow text='ID:'
                  value={simCard.get('externalId', '')}
      />
      <DetailsRow text='Link ID:'
                  value={simCard.get('linkId', '')}
      />
      <DetailsRow text='Created:'
                  value={admin.utils.formatDate(simCard.get('created', ''))}
      />
      <DetailsRow text='Yoco State:'
                  value={simCard.get('yocoSimState', '').humanize()}
      />
      <DetailsRow text='Provider State:' value={providerSimCardState}/>
        <DetailsRow text='Limit (MB):' value={dataInfo ? dataInfo.get('dataLimit', '') : ""}/>
        <DetailsRow text='Usage (MB):' value={dataInfo ? dataInfo.get('dataUsage', '') : ""}/>
      <BigDetailsRow
          id='serviceProviderResponse'
          text='Service Provider Response:'
          toggle={toggleServiceProviderResponse}
          show={showServiceProviderResponse}
          value={JSON.stringify(serviceProviderResponse, null, 4)} />
    </div>
);

const DetailsSubContainer = ({heading,rows,isRed=false}) => (
  <div className={`simCardDetailsSubContainer ${isRed ? 'redBlock' : ''}`}>
    <header className='simCardDetailsSubContainerHeader'>
      <h2 className='simCardDetailsSubHeading'>
        {heading}
      </h2>
    </header>
    {rows}
  </div>
);

const DetailsRow = ({text, value}) => (
    <div className='simCardDetailsRow'>
      <div className='simCardDetailsDescription'>
        {text}
      </div>
      <div className='simCardDetailsValue'>
        {value}
      </div>
    </div>
);

const BigDetailsRow = ({id, text, value, show, toggle}) => (
    <div className='simCardBigDetailsRow'>
        <div className='simCardDetailsDescription'>
            {text}
        </div>
        <div className='simCardDetailsValue'>
            <button onClick={toggle}>{show ? 'Hide': 'Show'}</button>
            {show ?
                <div id={id} >
                    <pre>{value}</pre>
                </div> : ''}
        </div>
    </div>
);

const TrackingDataRows = ({fulfilmentState, location}) => (
  <div>
    <DetailsRow text='Fulfilment State:' value={fulfilmentState.humanize()} />
    <DetailsRow text='Location:' value={location.humanize()} />
  </div>
);

class SimCardsProviderFilter extends waffle.filters.BaseFilter {
    loadAvailableOptions() {
        return {
            "eseye": {
                "icon": "star-1",
                "title": "Eseye",
                "selected": false
            },
            "hologram": {
                "icon": "star-1",
                "title": "Hologram",
                "selected": false
            },
            "ionline": {
                "icon": "star-1",
                "title": "iOnline",
                "selected": false
            }
        }
    }
}

SimCardsProviderFilter.defaultProps = {
    "emptySelectedString": "All Service Providers",
    "filterKey": "serviceProvider",
    "filterIcon": "icon-satellite"
};

class SimCardsStateFilter extends waffle.filters.BaseFilter {
    loadAvailableOptions() {
        return {
            "activated": {
                "title": "Activated",
                "selected": false
            },
            "pre_flight": {
                "title": "Pre-flight",
                "selected": false
            },
            "pending_termination": {
                "title": "Pending termination",
                "selected": false
            },
            "terminated": {
                "title": "Terminated",
                "selected": false
            }
        }
    }
}

SimCardsStateFilter.defaultProps = {
    "emptySelectedString": "All States",
    "filterKey": "yoco_sim_state"
};


class SimCardsLocationFilter extends waffle.filters.BaseFilter {
    loadAvailableOptions() {
        return {
            "accessify": {
                "title": "Accessify",
                "selected": false
            },
            "adair_business_solutions": {
                "title": "AdairBusinessSolutions",
                "selected": false
            },
            "amx": {
                "title": "Amx",
                "selected": false
            },
            "bizinbox": {
                "title": "Bizinbox",
                "selected": false
            },
            "brown_sense": {
                "title": "BrownSense",
                "selected": false
            },
            "builders": {
                "title": "Builders",
                "selected": false
            },
            "ccd_couriers": {
                "title": "CCDCouriers",
                "selected": false
            },
            "ccd_couriers_cape_town": {
                "title": "CCDCouriersCapeTown",
                "selected": false
            },
            "ccd_couriers_durban": {
                "title": "CCDCouriersDurban",
                "selected": false
            },
            "ccd_couriers_free_state": {
                "title": "CCDCouriersFreeState",
                "selected": false
            },
            "ccd_couriers_johannesburg": {
                "title": "CCDCouriersJohannesburg",
                "selected": false
            },
            "ccd_couriers_limpopo": {
                "title": "CCDCouriersLimpopo",
                "selected": false
            },
            "ccd_couriers_mthatha": {
                "title": "CCDCouriersMthatha",
                "selected": false
            },
            "ccd_couriers_northern_cape": {
                "title": "CCDCouriersNorthernCape",
                "selected": false
            },
            "ccd_couriers_port_elizabeth": {
                "title": "CCDCouriersPortElizabeth",
                "selected": false
            },
            "cellucity": {
                "title": "Cellucity",
                "selected": false
            },
            "cellc": {
                "title": "CellC",
                "selected": false
            },
            "chatz_connect": {
                "title": "ChatzConnect",
                "selected": false
            },
            "clicks": {
                "title": "Clicks",
                "selected": false
            },
            "digicape": {
                "title": "Digicape",
                "selected": false
            },
            "dis_chem": {
                "title": "DisChem",
                "selected": false
            },
            "ezypc": {
                "title": "Ezypc",
                "selected": false
            },
            "eazybranch": {
                "title": "Eazybranch",
                "selected": false
            },
            "field_agents": {
                "title": "FieldAgents",
                "selected": false
            },
            "foschini": {
                "title": "Foschini",
                "selected": false
            },
            "game": {
                "title": "Game",
                "selected": false
            },
            "hificorp": {
                "title": "HiFiCorp",
                "selected": false
            },
            "hp": {
                "title": "HP",
                "selected": false
            },
            "incredible_connection": {
                "title": "IncredibleConnection",
                "selected": false
            },
            "istore": {
                "title": "iStore",
                "selected": false
            },
            "jabil": {
                "title": "Jabil",
                "selected": false
            },
            "kozen": {
                "title": "Kozen",
                "selected": false
            },
            "makro": {
                "title": "Makro",
                "selected": false
            },
            "massmart_cash_and_carry": {
                "title": "MassmartCashAndCarry",
                "selected": false
            },
            "merchant": {
                "title": "Merchant",
                "selected": false
            },
            "mobi_fix": {
                "title": "MobiFix",
                "selected": false
            },
            "multi_choice": {
                "title": "MultiChoice",
                "selected": false
            },
            "one_day_only": {
                "title": "OneDayOnly",
                "selected": false
            },
            "pargo": {
                "title": "Pargo",
                "selected": false
            },
            "pep": {
                "title": "Pep",
                "selected": false
            },
            "pick_n_pay": {
                "title": "PickNPay",
                "selected": false
            },
            "post_net": {
                "title": "PostNet",
                "selected": false
            },
            "shopify": {
                "title": "Shopify",
                "selected": false
            },
            "shoprite": {
                "title": "Shoprite",
                "selected": false
            },
            "tabletpos": {
                "title": "TabletPos",
                "selected": false
            },
            "takealot": {
                "title": "Takealot",
                "selected": false
            },
            "telkom": {
                "title": "Telkom",
                "selected": false
            },
            "tpdc": {
                "title": "TPDC",
                "selected": false
            },
            "under_location_review": {
                "title": "UnderLocationReview",
                "selected": false
            },
            "waltons": {
                "title": "Waltons",
                "selected": false
            },
            "waste": {
                "title": "Waste",
                "selected": false
            },
            "wefix": {
                "title": "WeFix",
                "selected": false
            },
            "wumdrop": {
                "title": "Wumdrop",
                "selected": false
            },
            "yoco_head_office": {
                "title": "Yoco Head Office",
                "selected": false
            },
            "yoco_durban": {
                "title": "YocoDurban",
                "selected": false
            },
            "yoco_events": {
                "title": "YocoEvents",
                "selected": false
            },
            "yoco_key_accounts": {
                "title": "YocoKeyAccounts",
                "selected": false
            },
            "yoco_mauritius": {
                "title": "YocoMauritius",
                "selected": false
            },
            "yoco_nrd": {
                "title": "YocoNewRegionDevelopment",
                "selected": false
            },
            "yoco_outbound": {
                "title": "YocoOutbound",
                "selected": false
            },
            "yoco_pretoria": {
                "title": "YocoPretoria",
                "selected": false
            },
            "yoco_store_cape_town": {
                "title": "YocoStoreCapeTown",
                "selected": false
            },
            "yoco_store_johannesburg": {
                "title": "YocoStoreJohannesburg",
                "selected": false
            },
            "yoco_reseller": {
                "title": "YocoReseller",
                "selected": false
            },
        }
    }
}

SimCardsLocationFilter.defaultProps = {
    "emptySelectedString": "All Locations",
    "filterKey": "sim_location"
};

class SimCardsSKUFilter extends waffle.filters.BaseFilter {
    loadAvailableOptions() {
        return {
            "ESE001": {
                "title": "ESE001",
                "selected": false
            },
            "HLG001": {
                "title": "HLG001",
                "selected": false
            },
            "iON001": {
                "title": "ION001",
                "selected": false
            },
            "iON002": {
                "title": "ION002",
                "selected": false
            },
            "iON003": {
                "title": "ION003",
                "selected": false
            }
        }
    }
}

SimCardsSKUFilter.defaultProps = {
    "emptySelectedString": "All SKUs",
    "filterKey": "yoco_sku"
};

class SimCardsFilterBlock extends waffle.base.BaseComponent {
    render() {
        return <waffle.blocks.FilterBlock>
            <SimCardsProviderFilter />
            <SimCardsStateFilter />
            <SimCardsLocationFilter />
            <SimCardsSKUFilter />
        </waffle.blocks.FilterBlock>
    }
}

class AllocateToReaderBlock extends waffle.base.BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            selectedReaderSerialNumber: undefined
        };
    }

    readerSelected(serialNumber) {
        this.setState({
            selectedReaderSerialNumber: serialNumber
        });
    }

    render() {
        return (
            <div className='reader-allocation'>
                <header>
                    <h1>Allocate SIM</h1>
                </header>

                <div className='reader-allocation-container'>
                    <ReaderSelectField
                        simUUID={this.props.simUUID}
                        user_uuid={this.props.user_uuid}
                        setStateFromResponse={(response, status) => this.props.setStateFromResponse(response, status)}
                        scrollToElement={(element) => this.props.scrollToElement(element)}
                    />
                </div>
            </div>
        );
    }
}

class ReaderSelectField extends waffle.base.BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            reader: undefined,
            error: undefined
        };
    };

    componentDidMount() {
        let typingTimer;
        let doneTypingInterval = 1000;
        let searchInput = document.getElementById('reader-search-input');
        searchInput.addEventListener('keyup', () => {
            clearTimeout(typingTimer);
            if (searchInput.value && searchInput.value.length > 3) {
                typingTimer = setTimeout(() => { this.fetchReader() }, doneTypingInterval);
            }
        });
    }

    fetchReader() {
        const input = document.getElementById("reader-search-input");
        $.ajax({
            url: `/api/readers/simAllocationEligible/?serialNumber=${input.value}`,
            method: 'GET'
        }).done((response) => {
            radio('hideLoader').broadcast();
            if (response.status === 200) {
                this.setState({
                    reader: response.data.reader,
                    error: undefined
                });
            } else {
                this.setState({
                    reader: undefined,
                    error: response.message
                });
            }
        }).fail((response, textStatus) => {
            this.setState({
                reader: undefined,
                error: response.message
            });
        });
    }

    clear() {
        document.getElementById("reader-search-input").value = "";
        this.setState({
            reader: undefined
        });
    }

    getReaderTable() {
        if (this.state.reader) {
            return (
                <ReaderAllocationTable
                    reader={this.state.reader}
                    simUUID={this.props.simUUID}
                    user_uuid={this.props.user_uuid}
                    setStateFromResponse={(response, status) => this.props.setStateFromResponse(response, status)}
                    scrollToElement={(element) => this.props.scrollToElement(element)}
                />);
        } else {
            return '';
        }
    }

    getError() {
        if (this.state.error) {
            return (<div className="errors">
                <div className="alert alert-danger">{this.state.error}</div>
            </div>)
        } else {
            return '';
        }
    }

    render() {
        return (
            <div>
                <div className="business-select-field">
                    <label htmlFor="reader-search-input">READER</label>
                    <div className="search-container">
                        <input id="reader-search-input" placeholder="Enter serial number..." type="search" />
                        <span className="business-search-clear" onClick={() => this.clear()}>x</span>
                    </div>
                </div>
                {this.getReaderTable()}
                {this.getError()}
            </div>
        );
    }
}

class ReaderAllocationTable extends waffle.base.BaseComponent {
    constructor(props) {
        super(props);
    }

    allocateSim(performLock = false) {
        $.ajax({
            url: `/api/reader/simCards/${this.props.simUUID}/allocate${performLock ? '?performLock=true' : ''}`,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({ serialNumber: this.props.reader.serialNumber, updatedByUUID: this.props.user_uuid })
        }).done((response) => {
            if (response.status === 200) {
                this.props.setStateFromResponse(response, ACTIONS.INITIAL);
                location.reload()
            } else {
                radio('showAlert').broadcast('danger', `Allocation failed (${response.status}): ${response.message}`);
            }
        }).fail((_, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
            this.props.scrollToElement("simCardHeader");
        });
    }

    getBusinessLink() {
        if (this.props.reader.businessUUID) {
            return (<td><a target='_blank' href={`/businesses/${this.props.reader.businessUUID}`}>{this.props.reader.businessName}</a></td>)
        } else {
            return (<td>None</td>)
        }
    }

    render() {
        return (
            <div className='reader-table-container'>
                <table className='reader-table'>
                    <tbody>
                        <tr>
                            <th>Serial Number</th>
                            <th>SKU</th>
                            <th>Fulfilment State</th>
                            <th>Location</th>
                            <th>Business</th>
                        </tr>
                        <tr key={this.props.reader.readerUUID}>
                            <td><a target='_blank' href={`/logistics/card-readers/${this.props.reader.readerUUID}/`}>{this.props.reader.serialNumber}</a></td>
                            <td>{this.props.reader.yocoSku}</td>
                            <td>{this.props.reader.fulfilmentState.humanize()}</td>
                            <td>{this.props.reader.readerLocation.humanize()}</td>
                            {this.getBusinessLink()}
                            <td>
                                <waffle.misc.Button label='Allocate and Lock' className='blue-background' onClick={() => this.allocateSim(true)} />
                            </td>
                            <td>
                                <waffle.misc.Button label='Allocate' className='blue-background' onClick={() => this.allocateSim()} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

class FulfilmentAllocationsBlock extends waffle.base.BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedBusiness: undefined,
            fulfilments: undefined
        };
    }

    componentWillMount() {
    }

    businessSelected(business) {
        this.setState({
            selectedBusiness: business
        });

        this.getFulfilments(business.uuid);
    }

    // NO-OP so that we can keep the forms library happy
    onChange(value) {}

    hasBusinessSelectionChanged() {
        return this.state.selectedBusiness !== undefined &&
            (!this.state.previousBusinessUUID || this.state.selectedBusiness.uuid !== this.state.previousBusinessUUID)
    }

    getFulfilments(businessUUID) {
        radio('showLoader').broadcast();
        $.ajax({
            url: `/api/logistics/fulfilments?filters={"businessUUID":["${businessUUID}"]}`,
            method: 'GET'
        }).done((response) => {
            radio('hideLoader').broadcast();
            if (response.status === 200) {
                this.setState({
                    fulfilments: response.data
                });
            } else {
                radio('showAlert').broadcast('warn', `Failed to retrieve fulfilments for allocation (${response.status})`)
            }
        }).fail((_, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
        });
    }

    render() {
        const businessUUID = this.state.selectedBusiness ? this.state.selectedBusiness.uuid : undefined;

        return (
            <div className='reader-allocation'>
                <div className='reader-allocation-container'>
                    <logistics.BusinessSelectField
                        onFullOptionChanged={this.businessSelected.bind(this)}
                    />
                    <FulfilmentAllocationsTable
                        simNumber={this.props.simCard.simNumber}
                        simUUID={this.props.simUUID}
                        businessUUID={businessUUID}
                        fulfilments={this.state.fulfilments}
                        setStateFromResponse={(response, status) => this.props.setStateFromResponse(response, status)}
                        scrollToElement={(element) => this.props.scrollToElement(element)}
                    />
                </div>
            </div>
        );
    }
}

class FulfilmentAllocationsTable extends waffle.base.BaseComponent {
    constructor(props) {
        super(props);
    }

    static getHeading() {
        return (
            <tr>
                <th>Created</th>
                <th>Status</th>
                <th>View Details</th>
                <th>&nbsp;</th>
            </tr>
        );
    }

    allocateSIM(fulfilmentId) {
        let url = `/api/inventory/fulfilments/${fulfilmentId}/items`;
        radio('showLoader').broadcast();
        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                serial_number: this.props.simNumber,
            })
        }).done((response) => {
            radio('hideLoader').broadcast();
            if (response.status === 201) {
                radio('showAlert').broadcast('info', `Allocated SIM ${this.props.simNumber}`);
                window.location.reload();
            } else {
                radio('showAlert').broadcast('danger', `Allocation failed (${response.status}): ${response.message}`);
            }
            this.props.scrollToElement("simCardHeader");
        }).fail((_, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
            this.props.scrollToElement("simCardHeader");
        });
    }

    getRows() {
        return this.props.fulfilments.sort(
            function(a,b){
                return new Date(b.created_at) - new Date(a.created_at);
            }).map((fulfilment) => {
            return (<tr key={fulfilment.id}>
                <td>{admin.utils.formatDate(fulfilment.created_at)}</td>
                <td>{fulfilment.status.humanize()}</td>
                <td><a target='_blank' href={`/logistics/orders/fulfilments/${fulfilment.id}`}>View Details</a></td>
                <td>
                    <waffle.misc.Button label='Allocate'
                                        className='blue-background'
                                        onClick={() => this.allocateSIM(fulfilment.id)}/>
                </td>
            </tr>);
        });
    }

    render() {
        if (this.props.fulfilments && this.props.fulfilments.length > 0) {
            const heading = FulfilmentAllocationsTable.getHeading();
            const rows = this.getRows();
            return (
                <div className='reader-table-container'>
                    <table className='reader-table'>
                        <tbody>
                        {heading}
                        {rows}
                        </tbody>
                    </table>
                </div>
            );
        }
        // Return an empty div because we have neither a business selected nor any orders.
        return <div/>;
    }
}

module.exports = {
    SIMCardsPage,
    SimCardsFilterBlock: SimCardsFilterBlock
};
